import React from 'react';
import { toast } from 'react-toastify';
import Request from '../../components/AxiosInstance';
import { useNavigate } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import CodeLoginForm from '../../components/forms/CodeLoginForm';


export default function UpdateContact({method}) {

	const navigate = useNavigate();

	const contactType = method === 'text' ? 'Phone' : 'Email';

	const handleGetCode = async (payload) => {
		try {
			await Request.post('/api/account/reqcode', payload);
		} catch (e) {
			console.error(e);
		}
	}

	const handleCodeSubmit = async (payload) => {
		try {
			await Request.post('/api/account/vercode', payload);
			toast.success(`Your ${payload.method} has been updated to ${payload.receiver}`);
			navigate('/acc');
		} catch (e) {
			console.error(e);
		}
	}

	return (
		<Container component="main" maxWidth="xs">
			<Typography variant="h5">
				Update {contactType}
			</Typography>

			<CodeLoginForm
				method={method}
				handleGetCode={handleGetCode}
				handleCodeSubmit={handleCodeSubmit}
			/>
		</Container>
	)
}